import {CompanyCheckinsQuestions} from '@pages/dashboard/company-legacy/company-components/company-checkins/company-checkins-questions/company-checkins-questions';

export const CheckinsQuestion = () => {
  return (
    <div>
      <CompanyCheckinsQuestions />
    </div>
  );
};
